// extracted by mini-css-extract-plugin
module.exports = {"exportButton":"WebshopExportButton_exportButton__aijht"};